import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ce",
  "use": "icon-ce-usage",
  "viewBox": "0 0 1920 1080",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1920 1080\" id=\"icon-ce\">\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol